import { csrfToken } from "@/lib/orderActions"

async function jsonResponse(response) {
  const data = await response.json().catch(() => ({}))
  if (!response.ok) throw new Error(data.error || "We couldn't complete that invitation.")
  return data
}

export async function loadInvitationOptions(slug, { signal } = {}) {
  const response = await fetch(`/freelancers/${encodeURIComponent(slug)}/invitations`, {
    headers: { Accept: "application/json" },
    credentials: "same-origin",
    signal,
  })
  return jsonResponse(response)
}

export async function sendFreelancerInvitation(slug, { orderId, type, message }) {
  const response = await fetch(`/freelancers/${encodeURIComponent(slug)}/invitations`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "X-CSRF-Token": csrfToken(),
    },
    credentials: "same-origin",
    body: JSON.stringify({ order_id: orderId, type, message }),
  })
  return jsonResponse(response)
}
